import { useMutation } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import { logger } from "@/core/utils/func/logger";
import { adminEndpoints } from "@/features/admin/api/endpoints";
import type {
  DeviceSessionKeyExchangeRequestDto,
  DeviceSessionKeyExchangeResponseDto,
} from "@/features/admin/api/dto";

/**
 * ⚙️ Échange une clé publique de session device contre la clé publique
 * serveur (`POST /DeviceSessionKeys/exchange` — endpoint gateway, §6.1,
 * authentifié sans rôle particulier). Outillage de vérification du
 * chiffrement device ↔ serveur.
 */
export const useExchangeDeviceSessionKey = () =>
  useMutation({
    mutationKey: ["admin", "device-session-keys", "exchange"],
    mutationFn: (body: DeviceSessionKeyExchangeRequestDto) =>
      mutateData({
        url: adminEndpoints.deviceSessionKeys.exchange,
        reqBody: body as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<DeviceSessionKeyExchangeResponseDto>,
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useExchangeDeviceSessionKey failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "admin" }
      );
    },
  });
